/* CCC Courier theme v1.3.3 — address finder for the booking form.
   Uses Geoapify address autocomplete (the same service as the trade portal).
   Picking an address fills the street, town, county and postcode fields,
   which then validate and save exactly as if they'd been typed. */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.geoapify.com/v1/geocode/autocomplete';

  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: type !== 'blur' })); }

  function town(r) { return r.city || r.town || r.village || r.suburb || r.district || ''; }
  function county(r) {
    if (r.county) return r.county;
    if (r.state_district) return r.state_district;
    if (r.state && ['England', 'Wales', 'Scotland', 'Northern Ireland'].indexOf(r.state) === -1) return r.state;
    return r.city || '';
  }
  function street(r) {
    var line = [r.housenumber, r.street].filter(Boolean).join(' ');
    if (r.name && r.name !== r.street && r.name !== line) line = line ? r.name + ', ' + line : r.name;
    return line || r.address_line1 || '';
  }

  function init(box, key) {
    var side = box.getAttribute('data-address-search');
    var form = box.closest('form');
    var input = box.querySelector('[data-address-input]');
    var list = box.querySelector('[data-address-list]');
    var hint = box.querySelector('[data-address-hint]');
    if (!form || !input || !list) return;

    var results = [];
    var active = -1;
    var timer = null;
    var ctrl = null;
    var hintText = hint ? hint.textContent : '';

    function prop(name) { return form.querySelector('[data-prop="' + side + ' ' + name + '"]'); }

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function highlight(i) {
      var items = list.querySelectorAll('[role="option"]');
      if (!items.length) return;
      active = (i + items.length) % items.length;
      Array.prototype.forEach.call(items, function (li, n) { li.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', items[active].id);
      items[active].scrollIntoView({ block: 'nearest' });
    }

    function render() {
      list.innerHTML = '';
      if (!results.length) {
        var none = document.createElement('li');
        none.className = 'addr-find__empty';
        none.textContent = 'No matches. Try the postcode, or type the address below.';
        list.appendChild(none);
      }
      results.forEach(function (r, i) {
        var li = document.createElement('li');
        li.className = 'addr-find__option';
        li.id = input.id + '-opt-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        var main = document.createElement('span');
        main.className = 'addr-find__main';
        main.textContent = r.result_type === 'postcode' ? (r.postcode || r.formatted) : (street(r) || r.address_line1 || r.formatted);
        var sub = document.createElement('span');
        sub.className = 'addr-find__sub';
        sub.textContent = [town(r), r.postcode].filter(Boolean).join(', ');
        li.appendChild(main);
        li.appendChild(sub);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(i); });
        list.appendChild(li);
      });
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function set(name, value) {
      var el = prop(name);
      if (!el || !value) return null;
      el.value = value;
      fire(el, 'input');
      return el;
    }

    function pick(i) {
      var r = results[i];
      if (!r) return;
      var isPostcodeOnly = r.result_type === 'postcode';
      if (!isPostcodeOnly) set('Street Address', street(r));
      set('City', town(r));
      set('County', county(r));
      var pc = set('Postcode', r.postcode);
      if (pc) fire(pc, 'blur');
      close();
      input.value = r.formatted || '';
      box.classList.add('is-filled');
      if (hint) hint.textContent = isPostcodeOnly ? 'Postcode found. Add the house number and street below.' : 'Address added below. Check it and change anything that isn’t right.';
      var focusEl = isPostcodeOnly ? prop('Street Address') : null;
      if (focusEl) focusEl.focus();
      if (pc) fire(pc, 'change');
    }

    function search(text) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = ENDPOINT + '?text=' + encodeURIComponent(text) +
        '&filter=countrycode:gb&bias=countrycode:gb&lang=en&limit=6&format=json&apiKey=' + encodeURIComponent(key);
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          results = (data && data.results) || [];
          if (document.activeElement === input) render();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results = [];
          close();
          if (hint) hint.textContent = 'Address search isn’t working right now. Type the address below.';
        });
    }

    input.addEventListener('input', function () {
      var text = input.value.trim();
      box.classList.remove('is-filled');
      if (hint) hint.textContent = hintText;
      clearTimeout(timer);
      if (text.length < 3) { close(); return; }
      timer = setTimeout(function () { search(text); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden && results.length) render(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter') {
        /* Never submit the step from the finder */
        e.preventDefault();
        e.stopPropagation();
        if (!list.hidden && results.length) pick(active > -1 ? active : 0);
      }
      else if (e.key === 'Escape') { close(); }
    });

    input.addEventListener('blur', function () { setTimeout(close, 120); });
  }

  function start() {
    document.querySelectorAll('[data-booking]').forEach(function (root) {
      var key = root.getAttribute('data-geoapify-key');
      if (!key) return;
      root.querySelectorAll('[data-address-search]').forEach(function (box) {
        if (box.dataset.ready) return;
        box.dataset.ready = 'true';
        init(box, key);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
